import React, { useRef, useState } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import { Helmet } from "react-helmet";
import emailjs from "@emailjs/browser";
import backgroundImage from "../assets/contact_bg.png";
import withScroll from "../components/scroll";
import "../styles/contact.css";

const Contact = ({ sectionRef, handleScroll }) => {
  const form = useRef();
  const [isAnonymous, setIsAnonymous] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_xbass7h",
        "template_i8tm85o",
        form.current,
        "ghmqPSwlPgFKh5E6t"
      )
      .then(
        (result) => {
          console.log("SUCCESS!", result.text);
          alert("Message sent successfully!");
        },
        (error) => {
          console.log("FAILED...", error.text);
          alert("Failed to send message, please try again.");
        }
      );
  };

  return (
    <div className="contact-page">
      <Helmet>
        <title>Contact — Calvary First Nigerian SDA Church</title>
      </Helmet>
      <Navbar />
      <main>

        {/* ── Hero ── */}
        <section
          className="contact-hero"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <div className="contact-hero-content">
            <h1>Need to reach out to us?</h1>
          </div>
          <div className="contact-hero-buttons">
            <button className="contact-btn" onClick={handleScroll}>
              Contact Us
            </button>
          </div>
        </section>

        {/* ── Form + Info side by side ── */}
        <section ref={sectionRef} className="contact-main">
          <div className="contact-form-col">
            <h2 className="contact-col-head">Get in Touch</h2>
            <p className="contact-col-sub">We would love to hear from you</p>

            {/* Anonymous toggle */}
            <label className="anon-toggle-row">
              <span className="anon-label">Submit anonymously</span>
              <input
                type="checkbox"
                className="anon-checkbox"
                onChange={(e) => setIsAnonymous(e.target.checked)}
              />
            </label>

            <form className="contact-form" ref={form} onSubmit={sendEmail}>
              {!isAnonymous && (
                <>
                  <div className="form-row-2">
                    <div className="form-group">
                      <label htmlFor="firstname">First Name</label>
                      <input type="text" id="firstname" name="firstname" placeholder="First name" required />
                    </div>
                    <div className="form-group">
                      <label htmlFor="lastname">Last Name</label>
                      <input type="text" id="lastname" name="lastname" placeholder="Last name" required />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input type="email" id="email" name="email" placeholder="Your email" required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Phone</label>
                    <input type="tel" id="phone" name="phone" placeholder="Your phone number" required />
                  </div>
                </>
              )}
              <div className="form-group">
                <label htmlFor="message">Message / Prayer Request</label>
                <textarea id="message" name="message" placeholder="Write something..." required></textarea>
              </div>
              <div className="form-group">
                <label htmlFor="suggestions">Suggestions</label>
                <textarea id="suggestions" name="suggestions" placeholder="I think we should add..."></textarea>
              </div>
              <button type="submit" className="contact-submit-btn">
                Send Message
              </button>
            </form>
          </div>

          {/* Contact info column */}
          <div className="contact-info-col">
            <h2 className="contact-col-head">Contact Info</h2>
            <p className="contact-col-sub">We're always here for you</p>

            <div className="info-card">
              <p className="info-card-label">📍 Address</p>
              <p className="info-card-value">778 Lexington Ave<br />Brooklyn, NY 11221</p>
            </div>
            <div className="info-card">
              <p className="info-card-label">📞 Phone</p>
              <p className="info-card-value">(718) 919-9592</p>
            </div>
            <div className="info-card">
              <p className="info-card-label">🕐 Service Times</p>
              <p className="info-card-value">
                Sabbath School — Sat 9:30 AM<br />
                Divine Service — Sat 11:30 AM<br />
                Midweek Prayer — Wed 7:00 PM
              </p>
            </div>
          </div>
        </section>

        {/* ── Leadership ── */}
        <section className="leadership-section">
          <h2>Connect with Our Leadership</h2>
          <p className="leadership-sub">Reach out our church leaders</p>

          <div className="leadership-grid">

            {/* Pastor card */}
            <div className="leader-card">
              <div className="leader-card-top">
                <div className="leader-photo-wrap">
                  {/* Replace src with actual pastor photo */}
                  <div className="leader-photo-placeholder">Photo</div>
                </div>
                <p className="leader-name">Pastor Emmanuel Oduro Bediako</p>
                <span className="leader-title-badge">Pastor</span>
              </div>
              <div className="leader-card-body">
                <p className="leader-bio">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
                  eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                  enim ad minim veniam, quis nostrud exercitation ullamco.
                </p>
                <a href="tel:+17180000000" className="leader-phone">
                  📞 (718) 269-1739
                </a>
              </div>
            </div>

            {/* First Elder card */}
            <div className="leader-card">
              <div className="leader-card-top">
                <div className="leader-photo-wrap">
                  {/* Replace src with actual elder photo */}
                  <div className="leader-photo-placeholder">Photo</div>
                </div>
                <p className="leader-name">Elder David Awoyomi </p>
                <span className="leader-title-badge">First Elder</span>
              </div>
              <div className="leader-card-body">
                <p className="leader-bio">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
                  eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                  enim ad minim veniam, quis nostrud exercitation ullamco.
                </p>
                <a href="tel:+19170000000" className="leader-phone">
                  📞 (917) 575-0136
                </a>
              </div>
            </div>

          </div>
        </section>

        {/* ── Map ── */}
        <section className="contact-map-section">
          <h2>Find Us</h2>
          <p>778 Lexington Ave, Brooklyn, NY 11221</p>
          <div className="map-container">
            <iframe
              title="Calvary First SDA Church Location Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6050.539140290802!2d-73.93073402513672!3d40.69006033896026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25c0cf14276c7%3A0x6237d5299d070105!2sCalvary%20First%20Nigerian%20Seventh-Day%20Adventist%20Church!5e0!3m2!1sen!2sus!4v1723608180772!5m2!1sen!2sus"
              width="600"
              height="420"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </section>

      </main>
      <Footer />
    </div>
  );
};

export default withScroll(Contact);